import React from "react";
import { Box } from "@mui/material";
import { embeddedAgentPanelSx } from "../pages/ScopedAgentChatPanel";
import { useContextAgent } from "./ContextAgentContext";

export default function ContextAgentPanelHost() {
  const { handlersRef, open, setOpen, isRegistered, panelGeneration } = useContextAgent();
  void panelGeneration;

  const panel = handlersRef?.current?.panel;

  if (!isRegistered || !open || !panel) {
    return null;
  }

  const panelContent =
    typeof panel === "function" ? panel({ onClose: () => setOpen(false) }) : panel;

  return (
    <Box sx={embeddedAgentPanelSx} data-testid="context-agent-panel-host">
      {panelContent}
    </Box>
  );
}
